import { render, staticRenderFns } from "./HealthListList.vue?vue&type=template&id=d7ca5f78&scoped=true&"
import script from "./HealthListList.vue?vue&type=script&lang=js&"
export * from "./HealthListList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ca5f78",
  null
  
)

export default component.exports